import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chart",
  "use": "icon-chart-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-chart\">\r\n<path id=\"icon-chart_路径_2004\" d=\"M15.5,1h-11C2.2,1,0.4,2.9,0.4,5.2v9.6c0,2.3,1.9,4.1,4.1,4.1h11c2.3,0,4.1-1.9,4.1-4.1V5.2\r\n\tC19.6,2.9,17.8,1,15.5,1z M5.7,15.9c0,0.6-0.5,1-1,1s-1-0.5-1-1v-5.4c0-0.6,0.5-1,1-1s1,0.5,1,1V15.9z M11,16.5c0,0.6-0.5,1-1,1\r\n\tc-0.6,0-1-0.5-1-1V7c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1V16.5z M16.4,16.1c0,0.6-0.5,1-1,1c-0.6,0-1-0.5-1-1V8.4c0-0.6,0.5-1,1-1\r\n\tc0.6,0,1,0.5,1,1V16.1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol